import { render, staticRenderFns } from "./ViewAsRoleSnackbar.vue?vue&type=template&id=14849680"
import script from "./ViewAsRoleSnackbar.vue?vue&type=script&lang=js"
export * from "./ViewAsRoleSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports